import React from 'react';
import { matchPath } from "react-router-dom";

import { HIDE_REWARD_CLAIM_SECTION } from "utils/Config";
import { isInsideShopify } from "utils/UIConfigUtils";
import { NavType, BottomTabRouteType } from 'utils/CustomEnums'
import { bottomNavConfig } from 'frontend_common/ThemeConfig'
import i18n from 'utils/I18n';

export const getInboxUnreadCount = (messageUnreadCount) => {
  if (messageUnreadCount > 99) {
    return ' (99+)';
  }
  if (messageUnreadCount <= 0) {
    return '';
  }
  return ` (${messageUnreadCount})`;
};

const aboutNavItemList = [
  {
    name: "settings_app_about_lower",
    linkTo: process.env.REACT_APP_ABOUT_APP_LINK,
    external: true,
  },
  {
    name: "sign_up_terms_conditions",
    linkTo: process.env.REACT_APP_TERM_CONDITIONS_LINK,
    external: true,
  },
  {
    name: "sign_up_privacy_policy",
    linkTo: process.env.REACT_APP_PRIVACY_LINK,
    external: true,
  },
  {
    name: "FAQs",
    linkTo: process.env.REACT_APP_FAQS_LINK,
    external: true,
  },
]

const homeRoute = {
  linkTo: "/home",
  imageUrl: '/menu/home.svg',
  navType: NavType.LINK_TEXT,
  routeType: BottomTabRouteType.BOTTOM_TAB_HOME,
  exact: true,
}

const offerRoute = {
  linkTo: "/offer/LATEST",
  includeParentPathname: '/offer',
  imageUrl: '/menu/offer.svg',
  navType: NavType.LINK_TEXT,
  routeType: BottomTabRouteType.BOTTOM_TAB_OFFER,
  exact: false,
}

const storeRoute = {
  linkTo: "/store",
  imageUrl: '/menu/about.svg',
  navType: NavType.LINK_TEXT,
  routeType: BottomTabRouteType.BOTTOM_TAB_LOCATION,
  exact: true,
}

const aboutPage = {
  name: "about_upper",
  linkTo: "/about",
  imageUrl: '/menu/about.svg',
  navType: NavType.DROP_DOWN,
  navDropList: aboutNavItemList
}

const rewardClaimPage = {
  linkTo: "/transaction",
  imageUrl: '/menu/cart.svg',
  navType: NavType.LINK_TEXT,
  routeType: BottomTabRouteType.BOTTOM_TAB_RECORDS,
  exact: true,
}

const myProfilePage = {
  linkTo: "/user/myProfile",
  imageUrl: '',
  navType: NavType.LINK_TEXT,
  routeType: BottomTabRouteType.BOTTOM_TAB_PROFILE,
  exact: true,
}

const inboxPage = {
  name: "home_inbox",
  linkTo: "/inbox",
  imageUrl: '/menu/Inbox.svg',
  showUnreadCount: true,
  navType: NavType.LINK_TEXT,
}

const homeFamilyBookingRoute = {
    name: 'home_family_booking',
    imageUrl: '/menu/familyBooking.png',
    linkTo: '/family_booking',
    navType: NavType.LINK_TEXT,
    routeType: BottomTabRouteType.BOTTOM_TAB_FAMILY_BOOKING,
}

const patchAndReorder = (reorderList) => {
  const result = reorderList
    .filter(item => bottomNavConfig[item.routeType])
    .map(item => ({
      ...item,
      ...bottomNavConfig[item.routeType]
    }))
    .sort((x, y) => x.displayOrder - y.displayOrder);
  return result
}

const getLoginNavItems = () => {
  const items = [homeRoute, offerRoute]
  const insideShopify = isInsideShopify();
  if (!HIDE_REWARD_CLAIM_SECTION && !insideShopify) {
    items.push(rewardClaimPage)
  }
  if (!insideShopify) {
    items.push(storeRoute)
  }
  const newItems = patchAndReorder(items)
  if (!insideShopify) {
    newItems.push(aboutPage)
  }
  newItems.push(homeFamilyBookingRoute)
  newItems.push(inboxPage)
  return newItems
}

const getUnLoginNavItems = () => {
  const items = [homeRoute, offerRoute, storeRoute]
  const newItems = patchAndReorder(items)
  newItems.push(aboutPage)
  newItems.push(homeFamilyBookingRoute)
  return newItems
}

const getMobileBottomMainNavigator = () => {
  const items = [homeRoute, offerRoute, storeRoute, rewardClaimPage, myProfilePage]
  items.push(homeFamilyBookingRoute)
  const newItems = patchAndReorder(items)
  return newItems
}

export const unloginCommonNavItemList = getUnLoginNavItems()

export const loginCommonNavItemList = getLoginNavItems()


export const mobileBottomMainNavigator = getMobileBottomMainNavigator()

export const profileNavItemList = [
  {
    name: 'my_profile',
    linkTo: '/user/myProfile',
    imageUrl: '/menu/myProfile.svg',
  },
  {
    name: 'my_card',
    linkTo: '/user/myCard',
    imageUrl: '/menu/myCard.svg',
  },
  {
    name: 'profile_my_coupons',
    linkTo: '/user/myCoupon',
    imageUrl: '/menu/myCoupons.svg',
  },
  {
    name: 'myTicket',
    linkTo: '/user/myTicket',
    imageUrl: '/menu/myCoupons.svg',
  },
  {
    name: 'profile_my_account',
    linkTo: '/user/myAccount',
    imageUrl: '/menu/myAccount.svg',
  },
];

export const mobileDetectIsInMainNav = (pathname) => {
  const isInMainNav = [...mobileBottomMainNavigator, { linkTo: '/', exact: true }].some((mainRoute) => {
    const patchMatched = matchPath(pathname, { path: mainRoute.linkTo, exact: mainRoute.exact })
    const defaultRouteMatched = matchPath(pathname, { path: mainRoute.includeParentPathname, exact: mainRoute.exact })
    return patchMatched || defaultRouteMatched
  })
  return isInMainNav
}

export const mobileAttachActiveForMainNav = (pathname) => {
  return mobileBottomMainNavigator.map((mainRoute) => {
    const patchMatched = matchPath(pathname, { path: mainRoute.linkTo, exact: mainRoute.exact })
    const defaultRouteMatched = matchPath(pathname, { path: mainRoute.includeParentPathname, exact: mainRoute.exact })
    return {
      ...mainRoute,
      active: patchMatched || defaultRouteMatched
    }
  })
}

export const getCamelCase = ({ name, language }) => {
  const pageName = i18n.t(name, { lng: language || i18n.language })
  const nameList = pageName.split(' ')
  const upperNameList = nameList.map((item) => item.charAt(0).toUpperCase() + item.slice(1).toLowerCase())
  return upperNameList.join(" ");
}